<template>
  <div>
    <v-row align="center" style="margin: 0 20px">
      <v-col class="d-flex" cols="12" sm="4">
        <b>بخشی از کد ملی یا نام فرد:</b>
      </v-col>
      <v-col class="d-flex" cols="12" sm="4">
        <v-text-field v-model="searchInput" maxlength="10"></v-text-field>
      </v-col>
      <v-col cols="12" sm="4">
        <export-excel
          style="float: left"
          :data="users"
          :fields="excelHeaders"
          worksheet="My Worksheet"
          name="همه کاربران.xls"
        >
          <app-history title="خروجی اکسل" />
        </export-excel>
      </v-col>
    </v-row>

    <v-data-table
      :items="filteredUsers"
      :headers="headers"
      class="elevation-1 rounded"
      :footer-props="{
        itemsPerPageAllText: 'همه',
        itemsPerPageText: 'تعداد ردیف',
      }"
      :no-data-text="tableText"
      :header-props="$store.getters.headerProps"
    >
      <template v-slot:[`footer.page-text`]="{ pageStart, pageStop }">
        از {{ pageStart }} تا {{ pageStop }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Vue from "vue";
import HistoryButton from "@/components/HistoryButton";
import Dialog from "@/components/Dialog";
import { GetBranchUsers } from "@/api/branch";
import { FindUserByCode } from "@/api/user";
import moment from "moment-jalaali";
import { toArabicCharacter } from "@/utils/constants";
export default {
  components: {
    appHistory: HistoryButton,
  },
  data() {
    return {
      users: [],
      searchInput: "",
      headers: [
        {
          text: "نام",
          value: "fName",
          width: "30%",
        },
        {
          text: "نام خانوادگی",
          value: "lName",
          width: "45%",
        },
        {
          text: "کد ملی",
          value: "nationalCode",
          width: "15%",
          cellClass: "cellLtr",
        },
        {
          text: "نوع",
          value: "type",
          width: "10%",
        },
      ],
      excelHeaders: {
        نام: "fName",
        "نام خانوادگی": "lName",
        "کد ملی": "nationalCode",
        نوع: "type",
      },
    };
  },
  created() {
    if (this.currentBranch) this.GetBranchUsers();
  },
  computed: {
    tableText() {
      return this.$store.getters.tableText;
    },
    apiRunning() {
      return this.$store.getters.apiRunning;
    },
    currentBranch() {
      return this.$store.getters.currentBranch;
    },
    filteredUsers() {
      return this.users.filter((single) => {
        return (
          single.fName.includes(toArabicCharacter(this.searchInput)) ||
          single.lName.includes(toArabicCharacter(this.searchInput)) ||
          single.fName.includes(this.searchInput) ||
          single.lName.includes(this.searchInput) ||
          single.nationalCode.includes(this.searchInput)
        );
      });
    },
  },

  methods: {
    GetBranchUsers() {
      this.$store.commit("SET_TABLE_TEXT", true);
      return new Promise((resolve, reject) => {
        GetBranchUsers(this.currentBranch.id)
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            this.users = response.data;
            this.$store.commit("SET_TABLE_TEXT", false);

            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};
</script>
<style >
.text-start.cellLtr {
  direction: ltr;
  text-align: end !important;
}

.textLtr input {
  direction: ltr;
  text-align: right;
}

.filterButton {
  width: 100%;
}
</style>
